var MapsVector = function () {

  var setMap = function (name) {
    var data = {
      map: name + '_en',
      backgroundColor: null,
      borderColor: '#fff',
      borderOpacity: 0.5,
      borderWidth: 1,
      color: '#cdcdcd',
      enableZoom: false,
      hoverColor: '#AFAD98',
      hoverOpacity: null,
      selectedColor: '#AFAD98',
      selectedRegion: null,
      showTooltip: true,
      onRegionOver: function (event, code) {
        //                //sample to interact with map
        //                if (code == 'ca') {
        //                    event.preventDefault();
        //                }
      },
      onRegionClick: function (element, code, region) {
        element.preventDefault();
        $('#no-results').hide();
        $('.locate-block').hide();
        
        var locateType = $('.locator').attr('data-locate-type');        
        
        $('#state-text').text('First Tactical ' + locateType + 's in ' + region);
        
        var locateCount = 0
        
        $('.locate-block').each(function(){
          var states = $(this).attr('data-states');
          if(states) {
            if(states.indexOf(code.toUpperCase()) >= 0) {
              $(this).show();
              locateCount++;
            }
          }
        });
        
        if(locateCount == 0 ){
          $('#no-results').show();
        }
        
        $('#popresults').trigger('click');
      }
    };

    data.map = name + '_en';
    var map = jQuery('#vmap_' + name);
    if (!map) {
      return;
    }
    //       map.width(map.parent().width());
    map.vectorMap(data);
  }


  return {
    //main function to initiate map samples
    init: function () {
      setMap('usa');
    }

  };

}();

jQuery(document).ready(function () {
  MapsVector.init();
});